"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartTradeProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const SimpleTrading_1 = require("../SimpleTrading");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
exports.SmartTradeProcessor = {
    useUserParams: (price, trigglePrice, amount, amountPercent, enableTrailingStop, amountActionType, trailingPercentText, trailingPercentSlider, trailingPercentAction, stopLoss, quoteAvailable, symbol, orderType) => {
        const maxTrailingPercent = (0, react_1.useMemo)(() => {
            if (Number(price) && Number(trigglePrice) && Number(trigglePrice) > Number(price)) {
                const triggle = new trade_utils_lib_1.SafeDecimal(trigglePrice);
                const max = triggle.sub(new trade_utils_lib_1.SafeDecimal(price)).div(triggle);
                return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(max, 2);
            }
            return "0";
        }, [price, trigglePrice]);
        const [tempTrailingPercentText, tempTrailingPerccenNumber] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useTextAndSlider(trailingPercentAction, trailingPercentText, trailingPercentSlider, "0", maxTrailingPercent, true, 0);
        const [parseTrailingPercentText, parseTrailingPerccenNumber] = (0, react_1.useMemo)(() => {
            if (enableTrailingStop) {
                return [tempTrailingPercentText, tempTrailingPerccenNumber];
            }
            else {
                return ["", 0];
            }
        }, [enableTrailingStop, tempTrailingPercentText, tempTrailingPerccenNumber]);
        const minAmount = (0, react_1.useMemo)(() => {
            var _a;
            const sellMin = (_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.min;
            const checkPrice = Number(stopLoss) ? Number(stopLoss) : Number(price);
            const limitMin = SimpleTrading_1.SimpleTrading.getMinAmount(symbol, checkPrice);
            const min = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(sellMin), new trade_utils_lib_1.SafeDecimal(limitMin)).mul(1.05);
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(min, symbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        }, [symbol, price, stopLoss]);
        const balance = (0, react_1.useMemo)(() => {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAvailable, symbol.precision);
        }, [symbol, quoteAvailable]);
        const [parseAmount, parseAmountPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useInvestAndInvestPercent(amountActionType, price, amount, amountPercent, TradeAPILib_1.ExchangeOrderSide.buy, balance, symbol.amount);
        const volume = (0, react_1.useMemo)(() => {
            if (!price || !parseAmount) {
                return "0";
            }
            const value = new trade_utils_lib_1.SafeDecimal(price).mul(new trade_utils_lib_1.SafeDecimal(parseAmount));
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(value, symbol.precision);
        }, [price, parseAmount, symbol.precision]);
        const amountState = (0, react_1.useMemo)(() => {
            var _a, _b, _c, _d;
            const state = {
                state: "normal",
                min: minAmount + `(${symbol.baseDisplay})`,
                max: ""
            };
            if (parseAmount && Number(volume) && Number(price)) {
                let max = new trade_utils_lib_1.SafeDecimal(balance).div(new trade_utils_lib_1.SafeDecimal(price));
                if ((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.max) {
                    const maxDumping = new trade_utils_lib_1.SafeDecimal((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.dumping.max);
                    max = trade_utils_lib_1.SafeDecimal.min(max, maxDumping);
                }
                if ((_c = symbol.limit) === null || _c === void 0 ? void 0 : _c.amount.max) {
                    max = trade_utils_lib_1.SafeDecimal.min(max, new trade_utils_lib_1.SafeDecimal((_d = symbol.limit) === null || _d === void 0 ? void 0 : _d.amount.max));
                }
                state.max = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(max, symbol.amount) + `(${symbol.baseDisplay})`;
                if (new trade_utils_lib_1.SafeDecimal(parseAmount).lessThan(new trade_utils_lib_1.SafeDecimal(minAmount))) {
                    state.state = 'small';
                }
                if (new trade_utils_lib_1.SafeDecimal(parseAmount).greaterThan(max)) {
                    state.state = 'large';
                }
            }
            return state;
        }, [volume, minAmount, balance, parseAmount, symbol.symbol]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = [];
            if (!Number(price)) {
                emptys.push("trade_buy_price");
            }
            if (!Number(parseAmount)) {
                emptys.push("trade_buy_amount");
            }
            if (enableTrailingStop) {
                if (!Number(trigglePrice)) {
                    emptys.push("order_trigger_price");
                }
                if (!parseTrailingPercentText) {
                    emptys.push("trailing_stop_limit_place_holder_trailing_percent");
                }
            }
            else {
                if (!Number(trigglePrice)) {
                    emptys.push("order_trigger_sell_price");
                }
            }
            if (!stopLoss) {
                emptys.push("trade_stop_loss");
            }
            return emptys;
        }, [trigglePrice, price, parseAmount, enableTrailingStop, parseTrailingPercentText, stopLoss]);
        return {
            price, trigglePrice, amount: parseAmount, amountPercent: parseAmountPercent,
            enableTrailingStop, trailingPercentText: parseTrailingPercentText, trailingPercentSlider: parseTrailingPerccenNumber,
            maxTrailingPercent, stopLoss, balance, symbol, orderType, amountState, minAmount, volume, emptyErrors
        };
    },
    getCreateOrderRequest: (params, ticker, $st) => {
        var _a, _b, _c, _d, _e;
        if (params.emptyErrors.length > 0) {
            throw $st("trade_params_not_fill_enough");
        }
        const symbol = params.symbol;
        const buyPrice = new trade_utils_lib_1.SafeDecimal(params.price);
        const stoploss = new trade_utils_lib_1.SafeDecimal(params.stopLoss);
        const amount = new trade_utils_lib_1.SafeDecimal(params.amount);
        SimpleTrading_1.SimpleTrading.parseAmountSupportTrading(params.amount, params.symbol, params.price, $st);
        if (!SimpleTrading_1.SimpleTrading.checkPrice(params.price, symbol)) {
            throw $st("price_is_not_in_range_on_limit", { min: ((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.price.min) || "null", max: ((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.price.max) || "null" });
        }
        if (Number(params.stopLoss) && !SimpleTrading_1.SimpleTrading.checkPrice(params.stopLoss, symbol)) {
            throw $st("stop_loss_is_not_in_range_on_limit", { min: ((_c = symbol.limit) === null || _c === void 0 ? void 0 : _c.price.min) || "null", max: ((_d = symbol.limit) === null || _d === void 0 ? void 0 : _d.price.max) || "null" });
        }
        if (params.amountState.state === "small") {
            throw $st("trade_error_low_amount", {
                amount: `${params.minAmount} ${symbol.baseDisplay}`
            });
        }
        else if (params.amountState.state === "large") {
            const maxDumping = (_e = params.symbol.limit) === null || _e === void 0 ? void 0 : _e.dumping.max;
            if (maxDumping && amount.greaterThan(new trade_utils_lib_1.SafeDecimal(maxDumping))) {
                throw $st("trade_error_symbol_max_amount", { max: `${maxDumping} ${symbol.baseDisplay}` });
            }
            throw $st("trade_error_high_amount", { amount: `${params.amountState.max} ${symbol.baseDisplay}` });
        }
        if (new trade_utils_lib_1.SafeDecimal(params.trigglePrice).lessThanOrEqualTo(buyPrice)) {
            throw $st("take_profit_price_need_bigger_than_buy_price");
        }
        if (!params.enableTrailingStop && new trade_utils_lib_1.SafeDecimal(params.trigglePrice).lessThanOrEqualTo(stoploss)) {
            throw $st("take_profit_price_need_bigger_than_stop_loss");
        }
        if (stoploss.greaterThanOrEqualTo(buyPrice)) {
            throw $st("stop_loss_price_need_lower_than_buy_price");
        }
        if (stoploss.greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(ticker.latest))) {
            throw $st("grid_bullish_stop_loss_error_current_price");
        }
        const trailingPercent = new trade_utils_lib_1.SafeDecimal(params.trailingPercentText).div(100);
        if (params.enableTrailingStop && trailingPercent.greaterThan(new trade_utils_lib_1.SafeDecimal(params.maxTrailingPercent))) {
            const maxPercent = new trade_utils_lib_1.SafeDecimal(params.maxTrailingPercent).mul(100).toString();
            throw $st("trailing_percent_need_be_lower", { max: `${maxPercent}%` });
        }
        return {
            type: params.orderType,
            smart_type: TradeAPILib_1.SmartTradeType.smart_trade,
            base: symbol.base,
            quote: symbol.quote,
            buy: params.price,
            trigger: params.trigglePrice,
            amount: params.amount,
            trailing_percentage: trailingPercent.toString(),
            loss_stop: params.stopLoss,
            trailing_buy_percent: "0"
        };
    }
};
